export const SITE_KEY = '6LdrehQaAAAAADvd56yosX4i9K4Kq-iIFH6xiXlC';
export const SERVER_URL = 'https://mpk-security-zone.herokuapp.com';
// export const SERVER_URL = 'http://localhost:5000';